//import dependencies
import Vue from "vue";
import VueLogger from "vuejs-logger";
import axios from "axios";
import VueAxios from "vue-axios";
import SlideUpDown from "vue-slide-up-down";

//import plugins
import KrevoValidatorPlugin from "./plugins/vplug-validator";
import KrevoUrlPlugin from "./plugins/vplug-url";

//import app component file
import App from "./App.vue";

//import global component files
import Loader from "@/components/Loader.vue";
import RowInputText from "@/components/RowInputText.vue";
import RowInputCheckbox from "@/components/RowInputCheckbox.vue";
import RowSubmit from "@/components/RowSubmit.vue";
import FormSweepstakes from "./components/FormSweepstakes.vue";
Vue.component("Loader", Loader);
Vue.component("RowInputText", RowInputText);
Vue.component("RowInputCheckbox", RowInputCheckbox);
Vue.component("RowSubmit", RowSubmit);
Vue.component("FormSweepstakes", FormSweepstakes);

const isProduction = process.env.NODE_ENV === "production";
const vueLoggerOptions = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};
Vue.use(VueLogger, vueLoggerOptions);
Vue.use(VueAxios, axios);
Vue.component("slide-up-down", SlideUpDown);
Vue.use(KrevoValidatorPlugin);
Vue.use(KrevoUrlPlugin);
//window.$ = window.jQuery = require('jquery');

Vue.config.productionTip = false;
//creating the event bus
export const EventBus = new Vue();

new Vue({
  render: h => h(App)
}).$mount("#union");
